// in src/Layout.js
import {Layout} from 'react-admin';
import {Menu} from './Menu';

export const LayoutApp = (props) => <Layout {...props} menu={Menu}/>;
